/**
 * Outdoor functions, struck.
 *
 * A strike is the other half of a function: the lunch is over, the crew are
 * folding tables and stacking chairs onto carts, and somebody has to get the
 * carts up to the hotel. It posts on the board like an event, it has a deadline
 * like an event, and it is graded, but it is not a room: nothing is set, and
 * the work is the towing.
 *
 * One row per lawn. Everything here is data — where it is, which carts, what is
 * on the lawn — and `sim/teardown.js` reads it. Nothing in the logic knows a
 * lawn's name.
 *
 *   lawn      the room it happens in (`level.js`)
 *   dock      the room the carts have to end up in to count as delivered
 *   works     zones the job puts you in, which you may stand in while it is
 *             yours whatever anybody thinks of you (`access.js`)
 *   shifts    which of the week's shifts it posts on
 *   posts     minutes after the shift starts that it goes up, and is due
 *   carts     ids from `data/wheeled.js`: the carts the crew load
 *   stacks    what is on the lawn: a prop the crew carry from, the kind and
 *             count on it, and which kind of cart it goes on
 *   award     what an A is worth, scaled by the grade like any event
 *   estimate  minutes of work, for the board's arithmetic
 *
 * WHERE THE TOW ENDS, AND HOW IT GETS INSIDE
 *
 * At the foot of the apron stairs. The golf cart's row says it climbs 0.18 of
 * a metre, and the four risers up to the second roll-up door are 0.8 of a foot
 * each: it takes a kerb and not a stair, so it goes no further than the apron,
 * which is exactly where it went before there was anything to tow. A table cart
 * or a chair cart has no `climbs` of its own, so it takes a step the way a
 * person does, and every one of those risers is under that. So the carts are
 * unhitched on the apron and pushed up the stairs by hand, through the door the
 * stairs were built for, onto the platform. Nothing was added to the dock for
 * this: the stairs were put there so the apron was not a one-way drop, and a
 * cart on a rope follows a person up them.
 *
 * The apron is Valet's and it is restricted to anybody they do not know. While
 * a strike is yours it is not, because the apron belongs to whoever is working
 * it and you are. That is `works`, and it goes when the job does.
 */
export const TEARDOWNS = [
  {
    id: 'breeze',
    title: 'Strike the Breeze Lawn',
    client: 'After the garden luncheon',
    lawn: 'lawn',
    dock: 'dock',
    works: ['restricted-apron'],
    shifts: ['pm-banquet'],
    posts: { at: 30, due: 420 },
    carts: ['cart-lawn-tables', 'cart-lawn-chairs-1', 'cart-lawn-chairs-2'],
    stacks: [
      { prop: 'lawn-rounds', kind: 'round', count: 4, cart: 'tablecart' },
      { prop: 'lawn-chairs', kind: 'chair', count: 48, cart: 'chaircart' },
    ],
    award: { banquets: 12 },
    estimate: 240,
    note: 'The crew are striking the lawn. Get the golf cart from the staff lot, down the drive and along the lane to the lawn, back it up to each loaded cart, and tow them round to the apron. Push them up the stairs onto the dock.',
  },
];

export const TEARDOWNS_BY_ID = Object.freeze(Object.fromEntries(TEARDOWNS.map((row) => [row.id, row])));

export default TEARDOWNS;
